import SubBrandPage from "@/components/SubBrandPage";

export default function TheSocialSet() {
  return (
    <SubBrandPage meta={{
      slug: "social-set",
      tag: "Vibe",
      title: "The Social Set.",
      tagline: "DJs who read the room, keep the crowd, and make the night feel inevitable.",
      heroImg: "https://customer-assets-gfyr7b9c.emergentagent.net/job_simply-social-events/artifacts/couqhl0g_image000001.webp",
      overview: "Full-spectrum DJ services — from cocktail hour warm-ups to peak-hour sets — built around the energy of your specific crowd.",
      ctaLabel: "Book The Social Set",
      packages: [
        {
          name: "The Social Set", price: 75, priceLabel: "Per hour",
          meta: "4-hour minimum booking",
          includes: [
            "Premium JBL sound system",
            "High-energy open-format DJ service",
            "Custom mixes and blends",
            "MCing and crowd engagement",
            "Professional setup and transitions",
          ],
          footnote: "Bookings shorter than 4 hours: $125 / hour. Weddings are priced by consultation.",
        },
      ],
      pricingNote: "Weddings are priced by consultation — contact us for a custom quote.",
      sections: [
        { title: "Event Types",
          items: ["Weddings & receptions", "Corporate + brand events", "Private + rooftop parties", "Pop-ups & launches", "Birthdays + milestone nights", "Nightclub rental experiences"] },
        { title: "What's Included",
          copy: "Professional gear, clean setup, real crowd-reading. We build sets that respond to the room in real time." },
      ],
      faqs: [
        { q: "Do you take requests?", a: "Yes — with taste. We work from your must-play and do-not-play lists and read the crowd from there." },
        { q: "What's the minimum booking?", a: "4 hours at $75/hour. Anything shorter is billed at $125/hour." },
        { q: "How much are weddings?", a: "Weddings are quoted by consultation so we can build the exact set of hours and moments you need. Submit an inquiry to start." },
        { q: "Do you bring your own equipment?", a: "Yes — premium JBL sound system, controller, monitors, and mics included. Larger spaces may need our upgraded rig." },
      ],
    }} />
  );
}
